import { Box, ButtonBase, Container, styled, Typography } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import { Redirect, useHistory } from 'react-router-dom';
import fondo1 from './fondo1.jpg';
import fondo5 from './fondo5.jpg';
//import imagenes from '../img/1626Perfil.jpeg';
import img2 from '../img/perfil.png';
import img3 from '../img/1626.png';

const imagesTribunal = [
    {
        url: fondo1,
        titulo: 'Calificaciones',
        width: '25%',
        key: 'calificacionesTribunal'
    },
]

const imagesPersonal = [
    {
        url: fondo1,
        titulo: 'Mantenimiento de Archivos',
        width: '25%',
        key: 'mantenimiento'
    },
    {
        url: fondo1,
        titulo: 'Consultas',
        width: '25%',
        key: 'consultas'
    },
    {
        url: fondo1,
        titulo: 'Control de Asistencia',
        width: '25%',
        key: 'control'
    },
    {
        url: fondo1,
        titulo: 'Informes',
        width: '25%',
        key: 'informesPersonal'
    },
    {url: fondo1,
        titulo: 'Actividades Pendientes',
        width: '25%',
        key: 'actividadesPendientesPersonal'
    },
]

const imagesAdmin = [
    {
        url: fondo1,
        titulo: 'Mantenimiento de Archivos',
        width: '25%',
        key: 'mantenimiento'
    },
    {
        url: fondo1,
        titulo: 'Consultas',
        width: '25%',
        key: 'consultas'
    },
    {
        url: fondo1,
        titulo: 'Control de Asistencia',
        width: '25%',
        key: 'control'
    },
    {
        url: fondo1,
        titulo: 'Informes',
        width: '25%',
        key: 'informes'
    },
    {
        url: fondo1,
        titulo: 'Gestion de Usuarios',
        width: '25%',
        key: 'registro'
    },
    {
        url: fondo1,
        titulo: 'Pruebas',
        width: '25%',
        key: 'pruebas'
    }
]

/*const imagesFuncionario = [
    {url: fondo1,
        titulo: 'Consultas',
        width: '25%',
        key: 'consultasUsuario'
    },
    
    {url: fondo1,
        titulo: 'Solicitudes',
        width: '25%',
        key: 'solicitudesUsuario'
    },
    
    {url: fondo1,
        titulo: 'Calificaciones',
        width: '25%',
        key: 'calificacionesFuncionario'
    },
    
    {url: fondo1,
        titulo: 'Recibos Sueldos',
        width: '25%',
        key: 'recibosSueldos'
    },
    
    {url: fondo1,
        titulo: 'Llamados Publicados',
        width: '25%',
        key: 'llamadoFuncionarios'
    },
]*/

const imagesFuncionario = [
    {url: fondo1,
        titulo: 'Consultas',
        width: '25%',
        key: 'consultasUsuario'
    },
    
    {url: fondo1,
        titulo: 'Solicitudes',
        width: '25%',
        key: 'solicitudesUsuario'
    },
    
    {url: fondo1,
        titulo: 'Llamados Publicados',
        width: '25%',
        key: 'llamadoFuncionarios'
    },
]

const imagesJefes = [
    {url: fondo1,
        titulo: 'Solicitudes Pendientes',
        width: '25%',
        key: 'informesJefes'
    },
    {url: fondo1,
        titulo: 'Actividades Pendientes',
        width: '25%',
        key: 'actividadesPendientes'
    },
    {url: fondo1,
        titulo: 'Calificaciones',
        width: '25%',
        key: 'calificaciones'
    },
]

const imagesSV = [
    {url: fondo1,
        titulo: 'Solicitudes Pendientes',
        width: '25%',
        key: 'informesSV'
    },
]

const imagesJefeFinal = [
    {url: fondo1,
        titulo: 'Solicitudes Pendientes',
        width: '25%',
        key: 'informesJefeFinal'
    },
]

const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: 'relative',
    height: 200,
    [theme.breakpoints.down('sm')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &.Mui-focusVisible': {
      zIndex: 1,
      '& .MuiImageBackdrop-root': {
        opacity: 0.15,
      },
      '& .MuiImageMarked-root': {
        opacity: 0,
      },
      '& .MuiTypography-root': {
        border: '4px solid currentColor',
      },
    },
  }));

  const ImageSrc = styled('span')({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  });

  const Image = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  }));
  
  const ImageBackdrop = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  }));
  
  const ImageMarked = styled('span')(({ theme }) => ({
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  }));

class Inicio extends Component {
    constructor(props){
        super(props);
        this.state = {
            loginOk: false,
            log: '',
            mantenimiento: false,
            consultas: false,
            control: false,
            informes: false,
            gestionUsuarios: false,
            consultasUsuario: false,
            solicitudesUsuario: false,
            calificacionesFuncionario: false,
            informesJefes: false,
            actividadesPendientes: false,
            calificaciones: false,
            informesSV: false,
            informesJefeFinal: false,
            informesPersonal: false,
            actividadesPendientesPersonal: false,
            recibosSueldos: false,
            pruebas: false,
            calificacionesTribunal: false,
        }

        this.manejarClick = this.manejarClick.bind(this);
    }

    render(){
        return (
            <div>
                <Container style={{backgroundColor: '#F2F3F4'}}>
                    {sessionStorage.login && sessionStorage.tipoUsuario === '4' && (sessionStorage.primeraVez === '0')
                    ?
                        <Box sx={{ height: '85vh', width: '100%', display: 'flex', flexWrap: 'wrap', minWidth: 300, width: '100%' }}>
                            
                            {imagesPersonal.map((imagen) => (
                                <ImageButton focusRipple key={imagen.key} style={{width: imagen.width, marginTop: '1.5rem', marginLeft: '1rem'}}>
                                    <ImageSrc  style={{ backgroundImage: `url(${fondo5})` }}/>
                                    <ImageBackdrop className="MuiImageBackdrop-root" />
                                    <Image onClick={() => this.manejarClick(imagen)}>
                                        <Typography component="span"
                                            variant="subtitle1"
                                            color="inherit"
                                            sx={{
                                                position: 'relative',
                                                p: 4,
                                                pt: 2,
                                                pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                                            }}
                                        >
                                            {imagen.titulo}
                                            <ImageMarked className="MuiImageMarked-root" />
                                        </Typography>
                                    </Image>
                                </ImageButton>
                            ))}
                        </Box>
                    :
                        sessionStorage.login && sessionStorage.tipoUsuario === '2'
                        ?
                            <Box>
                                {imagesFuncionario.map((imagen) => (
                                    <ImageButton focusRipple key={imagen.key} style={{width: imagen.width, marginTop: '1.5rem', marginLeft: '1rem'}}>
                                        <ImageSrc  style={{ backgroundImage: `url(${fondo5})` }}/>
                                        <ImageBackdrop className="MuiImageBackdrop-root" />
                                        <Image onClick={() => this.manejarClick(imagen)}>
                                            <Typography component="span"
                                                variant="subtitle1"
                                                color="inherit"
                                                sx={{
                                                    position: 'relative',
                                                    p: 4,
                                                    pt: 2,
                                                    pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                                                }}
                                            >
                                                {imagen.titulo}
                                                <ImageMarked className="MuiImageMarked-root" />
                                            </Typography>
                                        </Image>
                                    </ImageButton>
                                ))}
                            </Box>
                        :
                            sessionStorage.login && sessionStorage.tipoUsuario === '3'
                            ?
                                <Box>
                                    {imagesJefes.map((imagen) => (
                                        <ImageButton focusRipple key={imagen.key} style={{width: imagen.width, marginTop: '1.5rem', marginLeft: '1rem'}}>
                                            <ImageSrc  style={{ backgroundImage: `url(${fondo5})` }}/>
                                            <ImageBackdrop className="MuiImageBackdrop-root" />
                                            <Image onClick={() => this.manejarClick(imagen)}>
                                                <Typography component="span"
                                                    variant="subtitle1"
                                                    color="inherit"
                                                    sx={{
                                                        position: 'relative',
                                                        p: 4,
                                                        pt: 2,
                                                        pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                                                    }}
                                                >
                                                    {imagen.titulo}
                                                    <ImageMarked className="MuiImageMarked-root" />
                                                </Typography>
                                            </Image>
                                        </ImageButton>
                                    ))}
                                </Box>
                            :
                                sessionStorage.login && sessionStorage.tipoUsuario === '1'
                                ?
                                    <Box>
                                        {imagesAdmin.map((imagen) => (
                                            <ImageButton focusRipple key={imagen.key} style={{width: imagen.width, marginTop: '1.5rem', marginLeft: '1rem'}}>
                                                <ImageSrc  style={{ backgroundImage: `url(${fondo5})` }}/>
                                                <ImageBackdrop className="MuiImageBackdrop-root" />
                                                <Image onClick={() => this.manejarClick(imagen)}>
                                                    <Typography component="span"
                                                        variant="subtitle1"
                                                        color="inherit"
                                                        sx={{
                                                            position: 'relative',
                                                            p: 4,
                                                            pt: 2,
                                                            pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                                                        }}
                                                    >
                                                        {imagen.titulo}
                                                        <ImageMarked className="MuiImageMarked-root" />
                                                    </Typography>
                                                </Image>
                                            </ImageButton>
                                        ))}
                                    </Box>
                                :
                                    sessionStorage.login && sessionStorage.tipoUsuario === '6'
                                    ?
                                        <Box>
                                            {imagesSV.map((imagen) => (
                                                <ImageButton focusRipple key={imagen.key} style={{width: imagen.width, marginTop: '1.5rem', marginLeft: '1rem'}}>
                                                    <ImageSrc  style={{ backgroundImage: `url(${fondo5})` }}/>
                                                    <ImageBackdrop className="MuiImageBackdrop-root" />
                                                    <Image onClick={() => this.manejarClick(imagen)}>
                                                        <Typography component="span"
                                                            variant="subtitle1"
                                                            color="inherit"
                                                            sx={{
                                                                position: 'relative',
                                                                p: 4,
                                                                pt: 2,
                                                                pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                                                            }}
                                                        >
                                                            {imagen.titulo}
                                                            <ImageMarked className="MuiImageMarked-root" />
                                                        </Typography>
                                                    </Image>
                                                </ImageButton>
                                            ))}
                                        </Box>
                                    :
                                        sessionStorage.login && sessionStorage.tipoUsuario === '5'
                                        ?
                                            <Box>
                                                {imagesJefeFinal.map((imagen) => (
                                                    <ImageButton focusRipple key={imagen.key} style={{width: imagen.width, marginTop: '1.5rem', marginLeft: '1rem'}}>
                                                        <ImageSrc  style={{ backgroundImage: `url(${fondo5})` }}/>
                                                        <ImageBackdrop className="MuiImageBackdrop-root" />
                                                        <Image onClick={() => this.manejarClick(imagen)}>
                                                            <Typography component="span"
                                                                variant="subtitle1"
                                                                color="inherit"
                                                                sx={{
                                                                    position: 'relative',
                                                                    p: 4,
                                                                    pt: 2,
                                                                    pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                                                                }}
                                                            >
                                                                {imagen.titulo}
                                                                <ImageMarked className="MuiImageMarked-root" />
                                                            </Typography>
                                                        </Image>
                                                    </ImageButton>
                                                ))}
                                            </Box>
                                        :
                                            sessionStorage.login && sessionStorage.tipoUsuario === '7'
                                            ?
                                                <Box>
                                                    {imagesTribunal.map((imagen) => (
                                                        <ImageButton focusRipple key={imagen.key} style={{width: imagen.width, marginTop: '1.5rem', marginLeft: '1rem'}}>
                                                            <ImageSrc  style={{ backgroundImage: `url(${fondo5})` }}/>
                                                            <ImageBackdrop className="MuiImageBackdrop-root" />
                                                            <Image onClick={() => this.manejarClick(imagen)}>
                                                                <Typography component="span"
                                                                    variant="subtitle1"
                                                                    color="inherit"
                                                                    sx={{
                                                                        position: 'relative',
                                                                        p: 4,
                                                                        pt: 2,
                                                                        pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                                                                    }}
                                                                >
                                                                    {imagen.titulo}
                                                                    <ImageMarked className="MuiImageMarked-root" />
                                                                </Typography>
                                                            </Image>
                                                        </ImageButton>
                                                    ))}
                                                </Box>
                                            :
                                                <Redirect to='/personal-app/login'/>
                    }
                </Container>
                {this.state.mantenimiento
                ?
                    <Redirect to='MantArchivo'/>
                :
                    this.state.consultas
                    ?
                        <Redirect to='Consultas'/>
                    :
                        this.state.control
                        ?
                            <Redirect to='ControlAsistencia'/>
                        :
                            this.state.informes
                            ?
                                <Redirect to='Informes'/>
                            :
                                this.state.gestionUsuarios
                                ?
                                    <Redirect to='gestion-usuarios'/>
                                :
                                    this.state.consultasUsuario
                                    ?
                                        <Redirect to='Consultas-usuario'/>
                                    :
                                        this.state.solicitudesUsuario
                                        ?
                                            <Redirect to='Informes-usuario'/>
                                        :
                                            this.state.informesJefes
                                            ?
                                                <Redirect to='Informes-jefes'/>
                                            :
                                                this.state.informesSV
                                                ?
                                                    <Redirect to='Informes-SV'/>
                                                :
                                                    this.state.informesJefeFinal
                                                    ?
                                                        <Redirect to='Informes-JF'/>
                                                    :
                                                        this.state.informesPersonal
                                                        ?
                                                            <Redirect to='Informes-P'/>
                                                        :
                                                            this.state.recibosSueldos
                                                            ?
                                                                <Redirect to='http://http://192.168.1.206/genteag/genteag.aspx'/>
                                                            :
                                                            this.state.actividadesPendientes
                                                            ?
                                                                <Redirect to='Actividades-pendientes'/>
                                                            :
                                                                this.state.calificaciones
                                                                ?
                                                                    <Redirect to='Calificaciones'/>
                                                                :
                                                                    this.state.actividadesPendientesPersonal
                                                                    ?
                                                                        <Redirect to='Actividades-pendientes'/>
                                                                    :
                                                                        this.state.calificacionesFuncionario
                                                                        ?
                                                                            <Redirect to='Calificaciones'/>
                                                                            :
                                                                                this.state.pruebas
                                                                                ?
                                                                                    <Redirect to='Pruebas'/>
                                                                                :
                                                                                    this.state.calificacionesTribunal
                                                                                    ?
                                                                                        <Redirect to='Calificaciones'/>
                                                                                    :
                                                                                        null
                }
            </div>
        )//Final Return
    }//Final Render

    manejarClick(imagen){
        if(imagen.key === 'mantenimiento'){
            this.setState({
                mantenimiento: true,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'consultas'){
            this.setState({
                mantenimiento: false,
                consultas: true,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'consultasUsuario'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: true,
                solicitudesUsuario: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'solicitudesUsuario'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: true,
                calificacionesFuncionario: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'calificacionesFuncionario'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: true,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'control'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: true,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'informes'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: true,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'informesJefes'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                informesJefes: true,
                actividadesPendientes: false,
                calificaciones: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'actividadesPendientes'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                informesJefes: false,
                actividadesPendientes: true,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'calificaciones'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                informesJefes: false,
                actividadesPendientes: false,
                calificaciones: true,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'informesPersonal'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                informesJefes: false,
                actividadesPendientes: false,
                calificaciones: false,
                informesPersonal: true,
                actividadesPendientesPersonal: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'actividadesPendientesPersonal'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                informesJefes: false,
                actividadesPendientes: false,
                calificaciones: false,
                informesPersonal: false,
                actividadesPendientesPersonal: true,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'informesSV'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                informesJefes: false,
                actividadesPendientes: false,
                calificaciones: false,
                informesSV: true,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'informesJefeFinal'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                informesJefes: false,
                actividadesPendientes: false,
                calificaciones: false,
                informesSV: false,
                informesJefeFinal: true,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'registro'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: true,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'pruebas'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                recibosSueldos: false,
                pruebas: true,
                calificacionesTribunal: false,
            })
        }else if(imagen.key === 'calificacionesTribunal'){
            this.setState({
                mantenimiento: false,
                consultas: false,
                control: false,
                informes: false,
                gestionUsuarios: false,
                consultasUsuario: false,
                solicitudesUsuario: false,
                calificacionesFuncionario: false,
                recibosSueldos: false,
                pruebas: false,
                calificacionesTribunal: true,
            })
        }else if(imagen.key === 'recibosSueldos'){
            if(sessionStorage.lugar === '0'){
                window.open('http://192.168.1.206/genteag/genteag.aspx');
            }else{
                window.open('http://190.64.95.234:8078/genteag/genteag.aspx');
            }
        }else if(imagen.key === 'llamadoFuncionarios'){
            window.open('https://chlaep.org.uy/llamados/');
        }
        
    }
}

export default Inicio